// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1XjTo","file":"styles_file__3Yfwp"};